import React, { useState } from 'react';
import './Modal.css';

const AuthModal = ({ show, onClose, onAuth }) => {
  const [password, setPassword] = useState('');

  if (!show) {
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onAuth(password);
    setPassword('');
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>请输入密码</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>密码</label>
            <input 
              type="password" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              required 
              autoFocus
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
            <button type="submit" className="btn">确认</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthModal; 